<template>
    <v-card>
        <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
                <v-icon color="white">mdi-package-variant</v-icon> Gestione
                Packaging
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        @click="salvaGestionePackaging"
                        class="mr-16"
                        small
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                </template>
                <span>Salva Gestione Packaging</span>
            </v-tooltip>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
            <v-container fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12">
                        <v-data-table
                            :headers="headers_packaging"
                            hide-default-footer
                            hide-default-header
                            :items="items_packaging"
                        >
                            <template
                                v-slot:[`item.cod_articolo_packaging`]="{
                                    item,
                                }"
                            >
                                <v-text-field
                                    @change="item"
                                    v-model="
                                        packaging_sel.cod_articolo_packaging
                                    "
                                    label="Cod. Packaging"
                                    style="width: 150px"
                                />
                            </template>
                            <template v-slot:[`item.cod_confezione`]="{ item }">
                                <v-autocomplete
                                    @change="item"
                                    v-model="
                                        packaging_sel.id_articolo_confezione
                                    "
                                    :items="items_confezioni"
                                    item-text="cod_articolo"
                                    item-value="id_articolo"
                                    label="Cod. Confezione"
                                    style="width: 150px"
                                >
                                </v-autocomplete>
                            </template>
                            <template v-slot:[`item.qta_confezione`]="{ item }">
                                <v-text-field
                                    @change="item"
                                    single-line
                                    style="
                                        display: inline-block;
                                        margin-left: 5px;
                                        width: 50px;
                                    "
                                    type="number"
                                    v-model="packaging_sel.qta_confezione"
                                />
                            </template>
                            <template
                                v-slot:[`item.report_confezione`]="{ item }"
                            >
                                <v-btn
                                    :disabled="item.id_articolo_packaging == -1"
                                    @click="clickReportConfezione(item, 0)"
                                    small
                                >
                                    <v-icon color="primary">
                                        mdi-file-document
                                    </v-icon>
                                </v-btn>
                            </template>
                            <template
                                v-slot:[`item.cod_contenitore`]="{ item }"
                            >
                                <v-autocomplete
                                    @change="item"
                                    v-model="
                                        packaging_sel.id_articolo_contenitore
                                    "
                                    :items="items_contenitori"
                                    item-text="cod_articolo"
                                    item-value="id_articolo"
                                    label="Cod. Contenitore"
                                    style="width: 150px"
                                >
                                </v-autocomplete>
                            </template>
                            <template
                                v-slot:[`item.qta_contenitore`]="{ item }"
                            >
                                <v-text-field
                                    @change="item"
                                    v-model="packaging_sel.qta_contenitore"
                                    single-line
                                    style="
                                        display: inline-block;
                                        margin-left: 5px;
                                        width: 50px;
                                    "
                                    type="number"
                                />
                            </template>
                            <template
                                v-slot:[`item.report_contenitore`]="{ item }"
                            >
                                <v-btn
                                    :disabled="item.id_articolo_packaging == -1"
                                    @click="clickReportConfezione(item, 1)"
                                    small
                                >
                                    <v-icon color="primary">
                                        mdi-file-document
                                    </v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:[`item.cod_imballo`]="{ item }">
                                <v-autocomplete
                                    @change="item"
                                    v-model="packaging_sel.id_articolo_imballo"
                                    :items="items_imballi"
                                    item-text="cod_articolo"
                                    item-value="id_articolo"
                                    label="Cod. Imballo"
                                    style="width: 150px"
                                >
                                </v-autocomplete>
                            </template>
                            <template v-slot:[`item.qta_imballo`]="{ item }">
                                <v-text-field
                                    @change="item"
                                    v-model="packaging_sel.qta_imballo"
                                    single-line
                                    style="
                                        display: inline-block;
                                        margin-left: 5px;
                                        width: 50px;
                                    "
                                    type="number"
                                />
                            </template>
                            <template v-slot:[`item.report_imballo`]="{ item }">
                                <v-btn
                                    :disabled="item.id_articolo_packaging == -1"
                                    @click="clickReportConfezione(item, 2)"
                                    small
                                >
                                    <v-icon color="primary">
                                        mdi-file-document
                                    </v-icon>
                                </v-btn>
                            </template>
                            <template
                                v-slot:[`item.ragione_sociale`]="{ item }"
                            >
                                <v-autocomplete
                                    @change="item"
                                    v-model="packaging_sel.id_anagrafica"
                                    :items="items_clienti"
                                    item-text="ragione_sociale"
                                    item-value="id_anagrafica"
                                    label="Rag. Sociale"
                                    style="width: 150px"
                                >
                                </v-autocomplete>
                            </template>
                            <template v-slot:[`item.elimina`]="{ item }">
                                <v-btn @click="item" small>
                                    <v-icon color="error"> mdi-delete </v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-divider></v-divider>
                    </v-col>
                </v-row>
                <v-row>
                    <h2>Distinta Base Contenitore</h2>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-treeview
                            :items="items_treeview"
                            item-key="id_articolo"
                            open-all
                            v-if="items_treeview.length > 0"
                        >
                            <template v-slot:prepend="{ item }">
                                Q.tà {{ item.quantita }} x
                                {{ item.cod_articolo }} ({{
                                    item.des_articolo
                                }})

                                <b v-if="item.validita == 0">
                                    componente eliminato
                                </b>

                                <span v-else>
                                    <!-- Bottone di aggiunta livello superiore -->
                                    <!--<v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickAggiungiLivelloSuperiore(item)"
                        class="mx-5"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-debug-step-out </v-icon>
                      </v-btn>
                    </template>
                    <span>Aggiungi al Livello Superiore</span>
                  </v-tooltip>-->

                                    <!-- Bottone di modifica della quantità -->
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                class="mx-5"
                                                @click="modificaQuantita(item)"
                                                icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon color="primary">
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Modifica Quantità</span>
                                    </v-tooltip>

                                    <!-- Bottone di aggiunta livello inferiore -->
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                class="mr-5"
                                                @click="
                                                    clickAggiungiLivelloInferiore(
                                                        item
                                                    )
                                                "
                                                icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon color="primary">
                                                    mdi-debug-step-into
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span
                                            >Aggiungi al Livello Inferiore</span
                                        >
                                    </v-tooltip>
                                </span>

                                <!-- Bottone di eliminazione -->
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            class="mr-5"
                                            @click="
                                                switchValiditaComponente(item)
                                            "
                                            :color="
                                                item.validita == 1
                                                    ? ''
                                                    : 'error'
                                            "
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon
                                                :color="
                                                    item.validita == 1
                                                        ? 'error'
                                                        : 'white'
                                                "
                                            >
                                                {{
                                                    item.validita == 1
                                                        ? "mdi-close"
                                                        : "mdi-reload"
                                                }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Elimina</span>
                                </v-tooltip>
                            </template>
                        </v-treeview>

                        <!-- Bottone di aggiunta del contenitore -->
                        <v-tooltip bottom v-else>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="aggiungiContenitore"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="primary"> mdi-plus </v-icon>
                                </v-btn>
                            </template>
                            <span>Aggiungi Contenitore</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <!-- DIALOG cerca articolo -->
        <v-dialog v-model="dialog_report" color="indigo">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Associazioni
                        {{
                            tipologia_sel
                                ? tipologia_sel.name.charAt(0).toUpperCase() +
                                  tipologia_sel.name.slice(1)
                                : ""
                        }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-2"
                                @click="aggiungiAssociazione"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="primary">mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Agg. Associazione</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="salvaAssociazioni"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiAssDialog"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-data-table
                    :headers="headers_associazioni"
                    :items="
                        tipologia_sel != null
                            ? tipologia_sel.value == '0'
                                ? associazioni_confezione != null
                                    ? associazioni_confezione.filter(
                                          (e) => e.validita == 1
                                      )
                                    : []
                                : tipologia_sel.value == '1'
                                ? associazioni_contenitore != null
                                    ? associazioni_contenitore.filter(
                                          (e) => e.validita == 1
                                      )
                                    : []
                                : tipologia_sel.value == '2'
                                ? associazioni_imballo != null
                                    ? associazioni_imballo.filter(
                                          (e) => e.validita == 1
                                      )
                                    : []
                                : []
                            : []
                    "
                >
                    <!-- BOTTONE DETTAGLIO -->
                    <template v-slot:[`item.dettaglio`]="{ item }">
                        <v-btn small @click="goToDettaglioEichetta(item)">
                            <v-icon color="primary">mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <!-- SELECT ETICHETTA -->
                    <template v-slot:[`item.cod_report`]="{ item }">
                        <v-autocomplete
                            :items="items_labels"
                            item-text="cod_label"
                            item-value="id_label"
                            label="Etichetta"
                            v-model="item.id_label"
                        />
                    </template>
                    <template v-slot:[`item.tipologia`]="{ item }">
                        <v-autocomplete
                            :items="items_tipologia"
                            item-text="des"
                            item-value="val_int"
                            label="Tipologia"
                            v-model="item.tipologia"
                        />
                    </template>
                    <!-- <template v-slot:[`item.applicazione`]="{ item }">
            <v-autocomplete
              :items="items_applicazione"
              item-text="des_applicazione"
              item-value="value"
              label="Applicazione"
              v-model="item.applicazione"
            />
          </template> -->
                    <template v-slot:[`item.numero`]="{ item }">
                        <v-text-field
                            style="width: 60px"
                            type="number"
                            min="0"
                            v-model="item.numero"
                            label="Numero"
                        />
                    </template>

                    <!-- CHECKBOX -->
                    <template v-slot:[`item.editabile`]="{ item }">
                        <v-checkbox dense v-model="item.editabile" />
                    </template>

                    <template v-slot:[`item.stampa`]="{ item }">
                        <v-btn
                            :disabled="item.id_articolo_packaging_label == -1"
                            small
                            @click="GetEtichettaPDF(item)"
                        >
                            <v-icon color="primary">mdi-printer</v-icon>
                        </v-btn>
                    </template>
                    <!-- BOTTONE ELIMINA -->
                    <template v-slot:[`item.elimina`]="{ item }">
                        <v-btn small @click="eliminaAssociazione(item)">
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card>
            <v-overlay :value="overlay2">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </v-dialog>

        <v-dialog v-model="pdfdialog" width="800">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">
                        Stampa Etichetta</v-toolbar-title
                    >

                    <v-spacer></v-spacer>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="pdfdialog = false" small>
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-progress-linear
                    indeterminate
                    color="cyan"
                    v-if="loading"
                    id="progress"
                >
                </v-progress-linear>

                <v-col cols="12">
                    <iframe
                        :src="selected_pdf"
                        frameborder="0"
                        style="height: 70vh !important; width: 750px !important"
                    >
                    </iframe>
                </v-col>
            </v-card>
        </v-dialog>

        <!-- Dialog di selezione degli articoli da mettere in distinta base -->
        <v-dialog v-model="dialog_selezione" width="unset">
            <v-card style="max-width: 600px">
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Selezione
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <!-- Bottone di conferma del salvataggio -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="selezionaArticoli"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-check </v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialog_selezione = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon></v-btn
                            >
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text style="overflow-y: auto">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field
                                    @keydown.enter="cercaArticoli"
                                    v-model="cod_articolo_ricerca"
                                    style="max-width: 250px"
                                >
                                    <template v-slot:append-outer>
                                        <v-btn @click="cercaArticoli" small>
                                            <v-icon color="primary">
                                                mdi-magnify
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                            <v-col class="my-0 py-0" justify="center" cols="12">
                                <v-data-table
                                    dense
                                    :headers="headers_selezione"
                                    :items="items_selezione"
                                >
                                    <template
                                        v-slot:[`item.quantita`]="{ item }"
                                    >
                                        <v-text-field
                                            dense
                                            hide-details
                                            outlined
                                            style="border-radius: 0px"
                                            type="number"
                                            v-model.number="item.quantita"
                                        ></v-text-field>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>

            <!-- Overlay del dialog di selezione -->
            <v-overlay :value="overlay_selezione">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </v-dialog>

        <v-dialog v-model="dialog_qta_componente" width="350">
            <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                    Q.tà Componente
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- Bottone di salvataggio -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="salvaModificaComponente"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="success"> mdi-floppy </v-icon>
                        </v-btn>
                    </template>
                    <span>Salva</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <!-- Bottone di chiusura -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="chiudiModificaComponente"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                    </template>
                    <span>Chiudi</span>
                </v-tooltip>
            </v-toolbar>
            <v-card>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" align="center" justify="center">
                            <v-text-field
                                dense
                                hide-details
                                label="Quantita"
                                outlined
                                style="border-radius: 0px; max-width: 150px"
                                v-model="componente_sel.quantita"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- Overlay -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Associazione {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            // { nome: "cod_report", default_val: "" },
            { nome: "id_articolo_packaging_label", default_val: -1 },
            { nome: "id_label", default_val: null },
            { nome: "id_articolo_packaging", default_val: null },
            { nome: "editabile", default_val: 0 },
            // { nome: "applicazione", default_val: 0 },
            { nome: "numero", default_val: 0 },
            { nome: "tipologia", default_val: 0 },
            { nome: "tipologia", default_val: 0 },
            { nome: "tipo_packaging", default_val: 0 },
            { nome: "validita", default_val: 1 },
        ];

        return campi;
    }
}

class GestionePackaging {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setControlli();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setControlli();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutte i campi
    reset() {
        const campi = this.setControlli();
        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setControlli() {
        const campi = [
            { nome: "id_articolo_packaging", default_val: -1 },
            { nome: "cod_articolo_packaging", default_val: "" },
            { nome: "cod_confezione", default_val: "" },
            { nome: "cod_contenitore", default_val: "" },
            { nome: "cod_imballo", default_val: "" },
            { nome: "id_articolo", default_val: null },
            { nome: "id_articolo_confezione", default_val: "" },
            { nome: "qta_confezione", default_val: 0 },
            { nome: "id_articolo_contenitore", default_val: "" },
            { nome: "qta_contenitore", default_val: 0 },
            { nome: "id_articolo_imballo", default_val: "" },
            { nome: "qta_imballo", default_val: 0 },
            { nome: "id_anagrafica", default_val: null },
            { nome: "validita", default_val: 1 },
        ];
        return campi;
    }
}

export default {
    name: "GestionePackaging",
    components: {
        SnackbarQV,
    },
    props: {
        packaging: {
            type: Object,
            default: () => {},
        },
        data: {
            type: Object,
            default: () => {},
        },
        quicklabel_allowed: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            // Variabili d'appoggio
            associazione_sel: new Associazione(),
            cod_articolo_ricerca: "",
            componente_sel: new Object(),
            componente_sel_pointer: new Object(),
            elemento_treeview_sel: null,
            modalita_aggiunta: "",
            packaging_sel: new GestionePackaging(),
            selected_pdf: "",
            tipologia_sel: null,

            // Modal
            dialog_qta_componente: false,
            dialog_report: false,
            dialog_selezione: false,
            loading: false,
            overlay: false,
            overlay2: false,
            overlay_selezione: false,
            pdfdialog: false,

            // Array
            associazioni_confezione: [],
            associazioni_contenitore: [],
            associazioni_imballo: [],
            headers_associazioni: [
                {
                    text: "Stampa",
                    value: "stampa",
                    sortable: false,
                },
                {
                    text: "Cod. Etichetta",
                    value: "cod_report",
                    sortable: false,
                },
                {
                    text: "Tipologia",
                    value: "tipologia",
                    sortable: false,
                },
                // {
                //   text: "Applicazione",
                //   value: "applicazione",
                //   sortable: false,
                // },
                {
                    text: "Numero",
                    value: "numero",
                    sortable: false,
                },
                {
                    text: "Editabile",
                    value: "editabile",
                    sortable: false,
                },

                {
                    text: "Elimina",
                    value: "elimina",
                    sortable: false,
                },
            ],
            headers_packaging: [
                {
                    text: "Cod. Articolo Packaging",
                    value: "cod_articolo_packaging",
                    sortable: false,
                },
                {
                    text: "Cod. Confezione",
                    value: "cod_confezione",
                    sortable: false,
                },
                {
                    text: "Qta. Confezione",
                    value: "qta_confezione",
                    sortable: false,
                },
                {
                    text: "Report Confezione",
                    value: "report_confezione",
                    sortable: false,
                },
                {
                    text: "Cod. Contenitore",
                    value: "cod_contenitore",
                    sortable: false,
                },
                {
                    text: "Qta. Contenitore",
                    value: "qta_contenitore",
                    sortable: false,
                },
                {
                    text: "Report Contenitore",
                    value: "report_contenitore",
                    sortable: false,
                },
                {
                    text: "Cod. Imballo",
                    value: "cod_imballo",
                    sortable: false,
                },
                {
                    text: "Qta. Imballo",
                    value: "qta_imballo",
                    sortable: false,
                },
                {
                    text: "Report Imballo",
                    value: "report_imballo",
                    sortable: false,
                },
                {
                    text: "Ragione Sociale",
                    value: "ragione_sociale",
                    sortable: false,
                },
            ],
            headers_selezione: [
                {
                    text: "Quantità",
                    value: "quantita",
                    width: "150px",
                    sortable: false,
                },
                { text: "Codice", value: "cod_articolo", sortable: false },
                { text: "Descrizione", value: "des_articolo", sortable: false },
            ],
            items_applicazione: [
                { des_applicazione: "Imballo", value: 0 },
                { des_applicazione: "Contenitore", value: 1 },
                { des_applicazione: "Confezione", value: 2 },
            ],
            items_clienti: [],
            items_contenitori: [],
            items_confezioni: [],
            items_imballi: [],
            items_labels: [],
            items_packaging: [],
            items_selezione: new Array(),
            items_tipologia: [],
            items_treeview: new Array(),
            open: new Array(),
            tipologia: [
                { name: "confezione", value: 0 },
                { name: "contenitore", value: 1 },
                { name: "imballo", value: 2 },
            ],
        };
    },
    computed: {},
    watch: {
        packaging: {
            immediate: true,
            handler() {
                console.log("data prop:", this.packaging);
                if (this.packaging.id_articolo_packaging != -1) {
                    this.packaging_sel = new GestionePackaging(this.packaging);
                    console.log(
                        "packaging from prop nel watch: ",
                        this.packaging_sel
                    );
                    this.items_packaging[0] = this.packaging_sel;
                    console.log("items_packaging", this.items_packaging);
                } else {
                    this.packaging_sel = new GestionePackaging(this.data);

                    this.items_packaging[0] = this.packaging_sel;
                }

                this.getConfContImba();
            },
        },
    },
    methods: {
        aggiungiAssociazione() {
            let associazione_tmp = new Associazione();
            associazione_tmp.id_articolo_packaging =
                this.packaging_sel.id_articolo_packaging;
            if (this.tipologia_sel.value == "0") {
                this.associazioni_confezione.push(associazione_tmp);
            } else if (this.tipologia_sel.value == "1") {
                this.associazioni_contenitore.push(associazione_tmp);
            } else if (this.tipologia_sel.value == "2") {
                this.associazioni_imballo.push(associazione_tmp);
            }
        },
        aggiungiArtAlt() {
            this.dialog_agg_art = true;
        },
        aggiungiContenitore() {
            if (
                this.packaging.id_articolo_contenitore == null ||
                this.packaging.id_articolo_contenitore == ""
            ) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Selezionare un contenitore nella sezione Generale."
                );
                return;
            }

            this.items_treeview.push({
                id_articolo_packaging_distinta_base: -1,
                id_articolo_packaging: this.packaging.id_articolo_packaging,
                id_articolo_elemento_packaging: null,
                id_articolo: this.packaging.id_articolo_contenitore,
                cod_articolo: this.packaging.cod_contenitore,
                des_articolo: this.packaging.des_contenitore,
                quantita: 1,
                validita: 1,
                children: new Array(),
            });
        },
        appiattisciTreeview(arr_arg, arr_res) {
            arr_arg.forEach((elem) => {
                const obj_tmp = JSON.parse(JSON.stringify(elem));
                if (obj_tmp.children) {
                    delete obj_tmp.children;
                }

                arr_res.push(obj_tmp);

                if (elem.children.length > 0) {
                    this.appiattisciTreeview(elem.children, arr_res);
                }
            });
        },
        cercaArticoli() {
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.user_token,
                    cod_articolo: this.cod_articolo_ricerca,
                },
            };

            this.overlay_selezione = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay_selezione = false;

                    if (res.status === 200) {
                        res.data.lista.forEach((e) => {
                            e.quantita = 0;
                        });

                        this.items_selezione = res.data.lista;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non  stato possibile salvare i dati."
                        );
                    }
                })
                .catch((err) => {
                    this.overlay_selezione = false;
                    console.error(err);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non  stato possibile salvare i dati."
                    );
                });
        },
        chiudiAssDialog() {
            this.dialog_report = false;
            this.associazione_sel = null;
            this.associazioni = [];
        },
        chiudiModificaComponente() {
            this.componente_sel_pointer = new Object();
            this.dialog_qta_componente = false;
        },
        clickAggiungiLivelloInferiore(arg) {
            this.elemento_treeview_sel = arg.id_articolo;
            this.modalita_aggiunta = "inferiore";
            this.items_selezione = new Array();
            this.cod_articolo_ricerca = "";
            this.dialog_selezione = true;
        },
        clickAggiungiLivelloSuperiore(arg) {
            this.elemento_treeview_sel = arg.id_articolo;
            this.modalita_aggiunta = "superiore";
            this.cod_articolo_ricerca = "";
            this.items_selezione = new Array();
            this.dialog_selezione = true;
        },
        clickReportConfezione(item, arg) {
            console.log(item, arg);
            this.tipologia.forEach((e) => {
                if (e.value == arg) {
                    this.tipologia_sel = e;
                }
            });
            this.getAssociazioni(item);
            this.dialog_report = true;
        },
        costruisciTreeview(arr_arg, arr_res, arg_id) {
            arr_arg.forEach((elem_osservato) => {
                if (elem_osservato.id_articolo_elemento_packaging == arg_id) {
                    const obj_tmp = JSON.parse(JSON.stringify(elem_osservato));
                    obj_tmp.children = new Array();
                    if (
                        arr_arg.filter(
                            (e) =>
                                e.id_articolo_elemento_packaging ==
                                obj_tmp.id_articolo
                        ).length > 0
                    ) {
                        this.costruisciTreeview(
                            arr_arg,
                            obj_tmp.children,
                            obj_tmp.id_articolo
                        );
                    }
                    arr_res.push(obj_tmp);
                }
            });
        },
        eliminaAssociazione(item) {
            item.validita = 0;
            if (item.id_articolo_packaging_label != -1) {
                this.setAssociazione(this.tipologia_sel.value);
            } else {
                this.associazioni = this.associazioni.filter(
                    (e) => e.validita != 0
                );
            }
        },
        eliminaArtAlt(item) {
            item.validita = 0;
            this.setArticoloAlt();
        },
        getAssociazioni() {
            this.overlay2 = true;

            let getPackaging = {
                controller: "Label",
                method: "POST",
                richiesta: {
                    action:
                        this.quicklabel_allowed == 1
                            ? "getpackaginglabel"
                            : "getpackagingreport",
                    token: localStorage.getItem("user_token"),
                    id_articolo_packaging:
                        this.packaging_sel.id_articolo_packaging,
                    tipo_packaging: this.tipologia_sel.value,
                },
            };
            return this.$store
                .dispatch("api", getPackaging)
                .then((res) => {
                    // Se la risposta arriva fermo l'overlay di caricamento
                    this.overlay2 = false;

                    if (res.status === 200) {
                        if (this.tipologia_sel.value == 0) {
                            this.associazioni_confezione = res.data.filter(
                                (e) => e.tipo_packaging == 0
                            );
                        } else if (this.tipologia_sel.value == 1) {
                            this.associazioni_contenitore = res.data.filter(
                                (e) => e.tipo_packaging == 1
                            );
                        } else if (this.tipologia_sel.value == 2) {
                            this.associazioni_imballo = res.data.filter(
                                (e) => e.tipo_packaging == 2
                            );
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.overlay2 = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        getDistintaBasePackaging() {
            let request = {
                controller: "Label",
                method: "POST",
                richiesta: {
                    action: "getdistintabasepackaging",
                    token: localStorage.getItem("user_token"),
                    id_articolo_packaging:
                        this.packaging_sel.id_articolo_packaging,
                },
            };
            return this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.length > 0) {
                            this.costruisciTreeview(
                                res.data.result,
                                this.items_treeview,
                                null
                            );
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        getTipologie() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "TIPOLOGIA_ETICHETTA_PACKAGING",
                    filter: "validita = 1",
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.items_tipologia = res.data ? res.data : [];
                    } else {
                        this.$refs.SnackbarQV.print("orange", "Errore");
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print("error", "Errore");
                });
        },
        getConfContImba() {
            this.overlay = true;
            let getTabelle = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "TIPOARTICOLO",
                    filter: "val_txt='PACK' OR val_txt='CONF'",
                },
            };

            this.$store
                .dispatch("api", getTabelle)
                .then((res1) => {
                    if (res1.status === 200) {
                        this.overlay = false;
                        /* Ho ottenuto quali sono gli id delle categorie
                         * confezione, contenitore e imballo. Mi faccio
                         * mandare dal BE i dati di tutti gli articoli di
                         * ciascuna di queste categorie. */
                        res1.data.forEach((p) => {
                            // Prendo i dati delle confezioni
                            if (p.val_txt == "CONF") {
                                let imballoSearch = {
                                    controller: "Magazzino",
                                    method: "POST",
                                    richiesta: {
                                        action: "getarticoli",
                                        token: localStorage.getItem(
                                            "user_token"
                                        ),
                                        cod_articolo: "*",
                                        id_tipo: p.id_tabella,
                                    },
                                };

                                this.$store
                                    .dispatch("api", imballoSearch)
                                    .then((res2) => {
                                        if (res2.status === 200) {
                                            this.items_confezioni =
                                                res2.data.lista;
                                            this.items_confezioni.forEach(
                                                (e) => {
                                                    if (
                                                        e.cod_articolo ==
                                                        this.packaging_sel
                                                            .cod_confezione
                                                    ) {
                                                        this.packaging_sel.id_articolo_confezione =
                                                            e.id_articolo;
                                                    }
                                                }
                                            );
                                        } else {
                                            this.overlay = false;
                                            this.$refs.SnackbarQV.print(
                                                "orange",
                                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        this.overlay = false;
                                        this.$refs.SnackbarQV.print(
                                            "error",
                                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                        );
                                    });
                            }

                            // Prendo i dati dei contenitori
                            else if (p.val_txt == "PACK" && p.val_int == 0) {
                                let imballoSearch = {
                                    controller: "Magazzino",
                                    method: "POST",
                                    richiesta: {
                                        action: "getarticoli",
                                        token: localStorage.getItem(
                                            "user_token"
                                        ),
                                        cod_articolo: "*",
                                        id_tipo: p.id_tabella,
                                    },
                                };

                                this.$store
                                    .dispatch("api", imballoSearch)
                                    .then((res2) => {
                                        if (res2.status === 200) {
                                            this.items_contenitori =
                                                res2.data.lista;
                                            this.items_contenitori.forEach(
                                                (e) => {
                                                    if (
                                                        e.cod_articolo ==
                                                        this.packaging_sel
                                                            .cod_contenitore
                                                    ) {
                                                        this.packaging_sel.id_articolo_contenitore =
                                                            e.id_articolo;
                                                    }
                                                }
                                            );
                                        } else {
                                            this.overlay = false;
                                            this.$refs.SnackbarQV.print(
                                                "orange",
                                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        this.overlay = false;
                                        this.$refs.SnackbarQV.print(
                                            "error",
                                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                        );
                                    });
                            }

                            // Prendo i dati degli imballi e li uso per caricare
                            else if (p.val_txt == "PACK" && p.val_int == 1) {
                                let imballoSearch = {
                                    controller: "Magazzino",
                                    method: "POST",
                                    richiesta: {
                                        action: "getarticoli",
                                        token: localStorage.getItem(
                                            "user_token"
                                        ),
                                        cod_articolo: "*",
                                        id_tipo: p.id_tabella,
                                    },
                                };

                                this.$store
                                    .dispatch("api", imballoSearch)
                                    .then((res2) => {
                                        if (res2.status === 200) {
                                            this.items_imballi =
                                                res2.data.lista;
                                            this.items_imballi.forEach((e) => {
                                                if (
                                                    e.cod_articolo ==
                                                    this.packaging_sel
                                                        .cod_imballo
                                                ) {
                                                    this.packaging_sel.id_articolo_imballo =
                                                        e.id_articolo;
                                                }
                                            });
                                        } else {
                                            this.overlay = false;
                                            this.$refs.SnackbarQV.print(
                                                "orange",
                                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        this.overlay = false;
                                        this.$refs.SnackbarQV.print(
                                            "error",
                                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                        );
                                    });
                            }
                        });
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        getArticoliPackaging() {
            this.$emit("getarticolipackaging");
        },
        GetEtichettaPDF(item) {
            this.overlay2 = true;

            const request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: item.cod_report,
                    parametri: [
                        {
                            parametro: "@id_articolo_packaging",
                            valore: item.id_articolo_packaging,
                        },
                    ],
                },
            };
            this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const byteCharacters = atob(res.data.result);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.selected_pdf = blobUrl;
                        this.overlay2 = false;
                        this.pdfdialog = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore visualizzazione anteprima"
                        );
                        this.overlay2 = false;
                    }
                })
                .catch((err) => {
                    this.overlay2 = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore visualizzazione anteprima"
                        );
                    }
                });
        },
        getReports() {
            /* Dato che è necessario differenziare la logica di business BE
             * per dare i dati delle etichette a seconda che il modulo QuickLabel
             * sia abilitato (estrae da t_label_master) o meno (estrae da
             * t_report) a seconda del valore del flag per l'abilitazione di
             * QuickLabel faccio due chiamate diverse (lo faccio segnando due
             * action diverse a seconda del caso). */
            var request = {
                controller: "Label",
                method: "POST",
                richiesta: {
                    action:
                        this.quicklabel_allowed == 0
                            ? "getreport"
                            : "getreportlabel",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.items_labels = res.data;
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore");
                });
        },
        inserisciArticoliSopra(arr_dove, arr_cosa) {
            arr_dove.forEach((elem) => {
                if (
                    elem.children.filter(
                        (c) => c.id_articolo == this.elemento_treeview_sel
                    ).length > 0
                ) {
                    arr_cosa.forEach((arg) => {
                        elem.children.push({
                            id_articolo_packaging_distinta_base: -1,
                            id_articolo_packaging:
                                this.packaging.id_articolo_packaging,
                            id_articolo_elemento_packaging: elem.id_articolo,
                            id_articolo: arg.id_articolo,
                            validita: 1,
                            quantita: arg.quantita,
                            children: new Array(),
                        });
                    });
                } else {
                    this.inserisciArticoliSopra(elem.children, arr_cosa);
                }
            });
        },
        inserisciArticoliSotto(arr_dove, arr_cosa) {
            arr_dove.forEach((elem) => {
                if (elem.id_articolo == this.elemento_treeview_sel) {
                    arr_cosa.forEach((arg) => {
                        elem.children.push({
                            id_articolo_packaging_distinta_base: -1,
                            id_articolo_packaging:
                                this.packaging.id_articolo_packaging,
                            id_articolo_elemento_packaging: elem.id_articolo,
                            id_articolo: arg.id_articolo,
                            cod_articolo: arg.cod_articolo,
                            des_articolo: arg.des_articolo,
                            validita: 1,
                            quantita: arg.quantita,
                            children: new Array(),
                        });
                    });
                } else {
                    this.inserisciArticoliSotto(elem.children, arr_cosa);
                }
            });
        },
        modificaQuantita(arg) {
            this.componente_sel_pointer = arg;
            this.componente_sel = JSON.parse(JSON.stringify(arg));
            this.dialog_qta_componente = true;
        },
        salvaAssociazioni() {
            this.overlay2 = true;
            let arr_tmp = [];
            console.log("tipologia sel", this.tipologia_sel);
            if (this.tipologia_sel.value == "0") {
                this.associazioni_confezione.forEach((e) => {
                    e.tipo_packaging = this.tipologia_sel.value;
                    if (e.editabile == true) {
                        e.editabile = 1;
                    }
                    if (e.editabile == false) {
                        e.editabile = 0;
                    }
                });
                arr_tmp = this.associazioni_confezione;
            }
            if (this.tipologia_sel.value == "1") {
                this.associazioni_contenitore.forEach((e) => {
                    e.tipo_packaging = this.tipologia_sel.value;
                    if (e.editabile == true) {
                        e.editabile = 1;
                    }
                    if (e.editabile == false) {
                        e.editabile = 0;
                    }
                });
                arr_tmp = this.associazioni_contenitore;
            }
            if (this.tipologia_sel.value == "2") {
                this.associazioni_imballo.forEach((e) => {
                    e.tipo_packaging = this.tipologia_sel.value;
                    if (e.editabile == true) {
                        e.editabile = 1;
                    }
                    if (e.editabile == false) {
                        e.editabile = 0;
                    }
                });
                arr_tmp = this.associazioni_imballo;
            }
            var request = {
                controller: "Label",
                method: "PUT",
                richiesta: {
                    action: "setpackaginglabel",
                    token: localStorage.getItem("user_token"),
                    packaging_label: arr_tmp,
                    // tipo_packaging: this.tipologia_sel.value,
                    modulo_ql: this.quicklabel_allowed,
                },
            };

            this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status === 200) {
                        this.overlay2 = false;
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Dati salvati correttamente."
                        );
                    }
                })
                .catch(() => {
                    this.overlay2 = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });

            this.dialog_report = false;
        },
        salvaGestionePackaging() {
            const arr_tmp = new Array();
            this.appiattisciTreeview(
                this.items_treeview.filter(
                    (e) =>
                        e.validita == 1 ||
                        e.id_articolo_packaging_distinta_base > 0
                ),
                arr_tmp
            );

            // Elimino dall'array temporaneo i campi non necessari.
            arr_tmp.forEach((elem) => {
                if (elem.children_backup) {
                    delete elem.children_backup;
                }
            });

            const setPackaging = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setarticolopackaging",
                    token: localStorage.getItem("user_token"),
                    id_articolo: this.packaging_sel.id_articolo,
                    articolo_packaging: [this.packaging_sel],
                    articolo_packaging_immagini: [],
                    articolo_packaging_istruzioni: [],
                    articolo_packaging_distinta_base: arr_tmp,
                },
            };

            this.overlay = true;
            this.$store
                .dispatch("api", setPackaging)
                .then((res) => {
                    if (res.status === 200) {
                        this.getArticoliPackaging();
                        // Stampo una snackbar di conferma.
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Contenitore aggiornato correttamente."
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile salvare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile salvare i dati."
                    );
                });
        },
        salvaModificaComponente() {
            this.componente_sel_pointer.quantita = this.componente_sel.quantita;
            this.componente_sel_pointer = new Object();
            this.dialog_qta_componente = false;
        },
        selezionaArticoli() {
            // Controllo che ci siano articoli da aggiungere.
            if (
                this.items_selezione.filter((e) => e.quantita > 0).length == 0
            ) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Almeno un articolo deve avere quantità superiore a 0."
                );
                return;
            }

            // Prendo da parte gli articoli da aggiungere.
            const arr_arg = this.items_selezione.filter((e) => e.quantita > 0);

            /* Controllo che nessuno degli articoli da aggiungere
             * sia già presente nella distinta base.*/
            const arr_tmp = new Array();
            this.appiattisciTreeview(
                this.items_treeview.filter(
                    (e) =>
                        e.validita == 1 ||
                        e.id_articolo_packaging_distinta_base > 0
                ),
                arr_tmp
            );

            let chk_presente = false;

            arr_arg.forEach((elem) => {
                if (
                    arr_tmp.filter(
                        (elem_tmp) =>
                            elem.id_articolo == elem_tmp.id_articolo &&
                            elem_tmp.validita == 1
                    ).length > 0
                ) {
                    chk_presente = true;
                }
            });

            if (chk_presente == true) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Alcuni articoli selezionati sono già persenti in distinta base."
                );
                return;
            }

            switch (this.modalita_aggiunta) {
                case "inferiore":
                    this.inserisciArticoliSotto(this.items_treeview, arr_arg);
                    break;
                case "superiore":
                    this.inserisciArticoliSopra(this.items_treeview, arr_arg);
                    break;
                default:
                    break;
            }

            this.dialog_selezione = false;
        },
        setArticoloPackaging() {
            this.overlay = true;

            let request = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setarticolopackaging",
                    token: localStorage.getItem("user_token"),
                    articolo_packaging: this.articolo_sel,
                },
            };
            return this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Dati salvati correttamente."
                        );
                        this.getArticoloAlt();
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        setAssociazione(arg) {
            if (arg == 0) {
                this.associazioni_confezione.forEach((a) => {
                    if (a.editabile == true) {
                        a.editabile = 1;
                    }
                    if (a.editabile == false) {
                        a.editabile = 0;
                    }
                });
            }
            if (arg == 1) {
                this.associazioni_contenitore.forEach((a) => {
                    if (a.editabile == true) {
                        a.editabile = 1;
                    }
                    if (a.editabile == false) {
                        a.editabile = 0;
                    }
                });
            }
            if (arg == 2) {
                this.associazioni_imballo.forEach((a) => {
                    if (a.editabile == true) {
                        a.editabile = 1;
                    }
                    if (a.editabile == false) {
                        a.editabile = 0;
                    }
                });
            }

            this.overlay2 = true;
            var request = {
                controller: "Label",
                method: "PUT",
                richiesta: {
                    action: "setpackaginglabel",
                    token: localStorage.getItem("user_token"),
                    packaging_label:
                        arg == 0
                            ? this.associazioni_confezione
                            : arg == 1
                            ? this.associazioni_contenitore
                            : this.associazioni_imballo,
                    modulo_ql: this.quicklabel_allowed,
                },
            };

            this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status === 200) {
                        this.overlay2 = false;
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Dati salvati correttamente."
                        );
                        this.getAssociazioni();
                    }
                })
                .catch(() => {
                    this.overlay2 = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        switchValiditaComponente(arg) {
            arg.validita = arg.validita == 0 ? 1 : 0;

            if (arg.validita == 0) {
                arg.children_backup = JSON.parse(JSON.stringify(arg.children));
                arg.children = new Array();
            } else {
                arg.children = JSON.parse(JSON.stringify(arg.children_backup));
                delete arg.children_backup;
            }
        },
        getRagioneSociale() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getragionesociale",
                    token: localStorage.getItem("user_token"),
                    cod_anagrafica: "*",
                    des_anagrafica: "*",
                    tipo_anagrafica: "F",
                },
            };

            this.overlay = true;

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.items_clienti = Array.from(res.data);
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
            this.client = false;
        },
    },
    created() {},
    mounted() {
        this.getReports();
        this.getTipologie();
        this.getRagioneSociale();
        this.getDistintaBasePackaging();
    },
};
</script>
<style scoped></style>
